// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mHdT","col":"styles_col__1wPmT","actions":"styles_actions__3n2sh","conflict":"styles_conflict__Z9S-r"};